import { useMutation } from '@tanstack/react-query';

import OffersService, { LuxPlusScheduleDefaultUpdate } from '~/services/OffersService';

export function useUpdateLuxPlusScheduleDefaults() {
  return useMutation({
    mutationFn: (updates: Array<LuxPlusScheduleDefaultUpdate>) => OffersService.updateLuxPlusScheduleDefaults(updates),
  });
}
